<template>
  <div class="icon-wrapper" :class="addClass">
    <svg class="icon" :width="width" :height="height">
      <use
        v-bind="{
          'xlink:href': svgURI + '#' + name
        }"
      ></use>
    </svg>
    <slot></slot>
  </div>
</template>

<script>
export default {
  data() {
    return {
      svgURI: ""
    };
  },
  created() {
    // fetch the data when the view is created and the data is
    // already being observed
    this.fetchData();
  },
  watch: {
    // call again the method if the route changes
    $route: "fetchData"
  },
  methods: {
    fetchData() {
      this.svgURI = this.$svgURI;
    }
  },
  props: {
    name: String,
    addClass: String,
    width: {
      type: [Number, String],
      default: 24
    },
    height: {
      type: [Number, String],
      default: 24
    }
  }
};
</script>

<style scoped></style>
